import React, { useEffect } from "react";
import { SVG } from "@svgdotjs/svg.js";

const RetroBackground = () => {
  useEffect(() => {
    // Seleccionar el contenedor donde se añadirá el SVG
    const draw = SVG().addTo("#retro-background").size("100%", "100%");

    // Crear un patrón retro con líneas diagonales
    const pattern = draw.pattern(20, 20, (add) => {
      add.rect(20, 20).fill("#000"); // Fondo del patrón
      add.line(0, 0, 20, 20).stroke({ width: 1, color: "#ffcc00" }); // Línea amarilla
      add.line(20, 0, 0, 20).stroke({ width: 1, color: "#00ffcc" }); // Línea cian
    });

    // Aplicar el patrón al fondo
    draw.rect("100%", "100%").fill(pattern).opacity(0.2); // Ajustar opacidad
  }, []);

  return (
    <div
      id="retro-background"
      className="fixed inset-0 pointer-events-none -z-50"
      style={{
        zIndex: 1, // Asegura que esté sobre el fondo actual
        mixBlendMode: "overlay", // Mezcla con el fondo
      }}
    ></div>
  );
};

export default RetroBackground;